<template>
  <div id="app" v-show="show">
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {getToken} from '@/utils/cookie'
import {clearStore} from '@/utils/store'

export default {
  name: 'App',
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  created() {
    /**
     * 若cookie为空而storage不为空，说明是重新打开的浏览器，清空缓存
     */
    if (!getToken() && this.$store.state.login.access_token) {
      this.show = false
      clearStore()
      window.location.reload()
      console.info('清空缓存')
    } else {
      this.show = true
    }
  }

}
</script>
<style lang="scss">
#app {
  font-size: 12px;
}

/**
 * el-table全局样式修改，调整边框颜色
 */
// 内边距
.el-table--mini td, .el-table--mini th {
  /*padding: 0 0;*/
}

.el-table th {
  /*background: #E4E7ED;*/
  white-space: nowrap;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #606266;

  /deep/
  .gutter {
    display: table-cell !important;
  }
}

.el-table--border {
  border-top: 1px solid #d6d6d6;
  border-left: 1px solid #d6d6d6;
  border-right: 1px solid #d6d6d6;
  border-bottom: 1px solid #d6d6d6;
}

.el-table--border th, .el-table__fixed-right-patch {
  border-bottom: 1px solid #d6d6d6;
}

.el-table--border td,
.el-table--border th,
.el-table__body-wrapper
.el-table--border.is-scrolling-left
~ .el-table__fixed
.el-table
is-hidden {
  border-right: 1px solid #d6d6d6;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #d6d6d6;
}

.el-table--border th.gutter:last-of-type {
  border-bottom: 1px solid #ebeef5;
  border-bottom-width: 1px;
  border-right: 0px;
  background: #fff !important;
  display: block !important;
  width: 17px !important;
}

/*
 * el-radio 全局样式修改
 */
.el-radio-button__orig-radio:disabled:checked + .el-radio-button__inner {
  background-color: #999 !important;
}

.el-radio-button__orig-radio:disabled + .el-radio-button__inner {
  color: rgba(0, 0, 0, 0.8) !important;
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff !important;
  background-color: #409EFF !important;
}

/**
 * el-select 全局样式修改
 */
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #999;
  cursor: not-allowed;
}

/********************  dialog在body显示时使用的样式  **************************/
// table头部颜色
.el-table th {
  background: #F6F7FB !important;
}

// table当前选中行颜色
.el-table__body tr.current-row > td {
  background: #d9ecff !important;
}

// tree当前选中行颜色
.el-tree--highlight-current {
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: #d9ecff !important;
  }
}

// dialog内边距
.el-dialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
}

.el-radio {
  .el-radio.is-bordered {
    border: 1px solid #cccccc;
  }

  // 禁用时选择状态不明显
  .is-checked.el-radio__input.is-disabled + span.el-radio__label {
    color: rgb(102, 177, 255);
  }

  .is-checked.el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
    background-color: rgb(102, 177, 255);
  }
  .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
    background: #F5F7FA;
  }
}
.el-checkbox{
  // 禁用时选择状态不明显
  .el-checkbox__input.is-disabled.is-checked+.el-checkbox__label{
    color: rgb(102, 177, 255);
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
    background-color: rgb(102, 177, 255);
    border-color: rgb(102, 177, 255);
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after{
    border-color: #F5F7FA;
  }
}

// 图片预览关闭按钮
div.el-image-viewer__wrapper {
  span.el-image-viewer__close {
    color: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue